/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrganization400Response,
  CreateTemporalClosureRequest,
  GetClosableProducts200ResponseInner,
  GetTemporalClosures200ResponseInner,
} from '../models/index';
import {
    CreateOrganization400ResponseFromJSON,
    CreateOrganization400ResponseToJSON,
    CreateTemporalClosureRequestFromJSON,
    CreateTemporalClosureRequestToJSON,
    GetClosableProducts200ResponseInnerFromJSON,
    GetClosableProducts200ResponseInnerToJSON,
    GetTemporalClosures200ResponseInnerFromJSON,
    GetTemporalClosures200ResponseInnerToJSON,
} from '../models/index';

export interface CreateTemporalClosureOperationRequest {
    createTemporalClosureRequest: CreateTemporalClosureRequest;
}

export interface DeleteTemporalClosureRequest {
    closureId: string;
}

/**
 * 
 */
export class TemporalClosuresApi extends runtime.BaseAPI {

    /**
     */
    async createTemporalClosureRaw(requestParameters: CreateTemporalClosureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createTemporalClosureRequest'] == null) {
            throw new runtime.RequiredError(
                'createTemporalClosureRequest',
                'Required parameter "createTemporalClosureRequest" was null or undefined when calling createTemporalClosure().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/temporal-closures/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTemporalClosureRequestToJSON(requestParameters['createTemporalClosureRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createTemporalClosure(requestParameters: CreateTemporalClosureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createTemporalClosureRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteTemporalClosureRaw(requestParameters: DeleteTemporalClosureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['closureId'] == null) {
            throw new runtime.RequiredError(
                'closureId',
                'Required parameter "closureId" was null or undefined when calling deleteTemporalClosure().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/temporal-closures/{closureId}`.replace(`{${"closureId"}}`, encodeURIComponent(String(requestParameters['closureId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTemporalClosure(requestParameters: DeleteTemporalClosureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTemporalClosureRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getClosableProductsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetClosableProducts200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/temporal-closures/products`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetClosableProducts200ResponseInnerFromJSON));
    }

    /**
     */
    async getClosableProducts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetClosableProducts200ResponseInner>> {
        const response = await this.getClosableProductsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getTemporalClosuresRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTemporalClosures200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/temporal-closures/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTemporalClosures200ResponseInnerFromJSON));
    }

    /**
     */
    async getTemporalClosures(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTemporalClosures200ResponseInner>> {
        const response = await this.getTemporalClosuresRaw(initOverrides);
        return await response.value();
    }

}
